import { Pipe, PipeTransform } from '@angular/core';
import getSymbolFromCurrency from 'currency-symbol-map';

@Pipe({
  name: 'currencyToSymbol'
})
export class CurrencyToSymbolPipe implements PipeTransform {

  transform(value: string) {
    return getSymbolFromCurrency(value);
  }

}
